package com.narbase.letsgo.web.views.support

import com.narbase.kunafa.core.components.TextInput
import com.narbase.kunafa.core.components.TextView
import com.narbase.kunafa.core.components.horizontalLayout
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.components.verticalLayout
import com.narbase.kunafa.core.css.width
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.vw
import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.dto.core.MultiLingualTextDto
import com.narbase.letsgo.web.dto.support.ExtendedSupportItemDto
import com.narbase.letsgo.web.dto.support.SupportCategoryDto
import com.narbase.letsgo.web.theme.main.MainTheme
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.verticalFiller
import com.narbase.letsgo.web.utils.views.*
import com.narbase.letsgo.web.utils.views.customViews.CustomCheckBox
import com.narbase.letsgo.web.utils.views.customViews.customCheckBox

class UpsertSupportItemDialog(
    private var supportItem: ExtendedSupportItemDto?,
    val onUpdated: () -> Unit
) {
    private val viewModel = SupportManagementViewModel()
    private val popup by lazy { popUpDialog() }
    private var isActiveCheckBox: CustomCheckBox? = null

    var errorTextView: TextView? = null

    private var categoryTitleEnInput: TextInput? = null
    private var categoryTitleArInput: TextInput? = null
    private var categoryTitleFrInput: TextInput? = null

    fun show() {
        theme.showDialog(popup, customStyle = MainTheme.ThemeDialogStyle(minWidth = 60.vw)) {
            it.bottomBar = {
                horizontalLayout {
                    matchParentWidth()
                    horizontalFiller()
                    theme.unimportantButton(this) {
                        text = "Dismiss".localized()
                        onClick = {
                            popup.dismissDialog()
                        }
                    }
                    horizontalFiller(20)
                    horizontalLayout {
                        style {
                            width = wrapContent
                        }
                        theme.mainButton(this) {
                            text = "Save".localized()
                            onClick = {
                                save()
                            }
                        }.withLoadingAndError(viewModel.upsertUiState, onLoaded = {
                            popup.dismissDialog()
                            onUpdated.invoke()
                        }, onRetryClicked = {
                            save()
                        })
                    }
                }
            }

            mainForm()

        }
    }

    fun LinearLayout.mainForm() = verticalLayout {
        matchParentDimensions()
        categoryTitleEnInput = theme.labeledTextInput(this, "Title - en")
        categoryTitleEnInput?.text = supportItem?.category?.title?.en ?: ""
        verticalFiller(10)
        categoryTitleArInput = theme.labeledTextInput(this, "Title - ar")
        categoryTitleArInput?.text = supportItem?.category?.title?.ar ?: ""
        verticalFiller(10)
        categoryTitleFrInput = theme.labeledTextInput(this, "Title - fr")
        categoryTitleFrInput?.text = supportItem?.category?.title?.fr ?: ""
        verticalFiller(10)

        isActiveCheckBox = customCheckBox(
            "is category active".localized(), isSelected = supportItem?.category?.isActive ?: false
        )


        errorTextView = theme.errorText(this) {
            isVisible = false
        }

        val categoryId = supportItem?.category?.id
        if (categoryId != null) {
            issuesLayout(categoryId)
        }

    }
    fun LinearLayout.issuesLayout(categoryId: KmmLong) = verticalLayout {
        matchParentWidth()
        mount(SupportIssuesManagementComponent(categoryId))
    }


    fun save() {

        val titleEn = categoryTitleEnInput?.text?.trim()
        val titleAr = categoryTitleArInput?.text?.trim()
        val titleFr = categoryTitleFrInput?.text?.trim()
        val isActive = isActiveCheckBox?.isSelected ?: false

        if (titleEn.isNullOrBlank() || titleAr.isNullOrBlank() || titleFr.isNullOrBlank() ) {
            errorTextView?.text = "Title can't be null"
            errorTextView?.isVisible = true
            return
        }

        viewModel.upsertSupportCategory(
            SupportCategoryDto(
                id = supportItem?.category?.id,
                title = MultiLingualTextDto(titleEn, titleAr, titleFr),
                isActive = isActive,
                createdOn = supportItem?.category?.createdOn
            )
        )
    }

}